// サンプルブログ記事データをまとめたファイル

// すべての記事ファイルを自動的にインポートする
// Webpackのrequire.contextを使用して、postsディレクトリ内のすべてのjsファイルを取得
const postContext = require.context('./posts', false, /\.js$/);

// すべての記事データを格納する配列
export const sampleBlogPosts = postContext.keys().map(filename => {
    // ファイル名からモジュールをインポート
    const post = postContext(filename).default;
    return post;
});

// 関連記事の相互参照を処理する関数
const processRelatedPosts = () => {
    // スラッグから記事オブジェクトを取得できるマップを作成
    const postMap = {};
    sampleBlogPosts.forEach(post => {
        postMap[post.slug] = post;
    });

    // 各記事の関連記事を実際の記事オブジェクトに変換
    sampleBlogPosts.forEach(post => {
        if (post.relatedPosts && post.relatedPosts.length > 0) {
            const relatedPostObjects = post.relatedPosts
                .map(slug => postMap[slug])
                .filter(Boolean); // undefinedを除外

            // 記事オブジェクトの直接変更は避け、必要なときにrelatedPostsから取得する
            post._relatedPostObjects = relatedPostObjects;
        }
    });
};

// 関連記事の設定を処理
processRelatedPosts();

export default sampleBlogPosts; 